import React, { useState, useEffect } from "react";
import { GetData } from "../Components/Services";
import Loading from "../../../Common/Loading";
import JionClass from "../Components/JoinClass";
import Reseve from "../Components/Reseve";
import Contractual from "../Components/Contractual";
import { Helmet } from "react-helmet";
function Index({ isApp }) {
  const payed = window.location.href.split("pay=")[1];
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    HandlergGetdata();
  }, []);
  const HandlergGetdata = async () => {
    setState({ ...state, loading: true });
    await GetData(payed)
      .then(result => {
        setState({
          loading: false,
          data: result,
        });
      })
      .then(() => {
        setTimeout(() => {
          window.print();
        }, 2000);
      });
  };
  const checkType = data => {
    switch (data.type) {
      case "reserve":
        return <Reseve data={data.ticketdata} />;
      case "joinclass":
        return <JionClass data={data.ticketdata} />;
      case "contractual_reservation":
      case "contractual_reservation_installments":
        return <Contractual data={data.ticketdata} />;
    }
  };
  return (
    <>
      <Helmet>
        <title>نیکوتن | چاپ بلیت </title>
      </Helmet>
      <div className="container ticket">
        <div className={isApp ? "d-flex flex-wrap w-100 justify-content-center" : "row justify-content-evenly"}>
          {state.loading ? (
            <Loading count={1} col={12} height={300} />
          ) : (
            checkType(state.data)
          )}
        </div>
        <div className="d-flex justify-content-center m-5">
          <button
            className={isApp?"btn btn-primary w-100":"btn btn-orange"}
            onClick={() => {
              window.print();
            }}
          >
            چاپ
          </button>
        </div>
      </div>
    </>
  );
}

export default Index;
